var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureFileDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.239,
    height: 19.5,
    viewBox: "0 0 19.239 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160671",
    "data-name": "Group 160671",
    transform: "translate(-408.25 -448.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160576",
    "data-name": "Group 160576",
    transform: "translate(409 449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "secure_file_Filled",
    "data-name": "secure file_Filled",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M57.89,49.284A2.838,2.838,0,0,1,55.1,51.607H48.524a2.824,2.824,0,0,1-2.834-2.8V38.369a2.824,2.824,0,0,1,2.834-2.8H55.1a2.824,2.824,0,0,1,1.987.813",
    transform: "translate(-45.69 -33.607)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M62.906,53.37a2.948,2.948,0,0,1-2.066.847",
    transform: "translate(-48.925 -37.516)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_352",
    d: "M64.487,49.063H59.657a1.036,1.036,0,0,1-1.037-1.037V44.067a1.036,1.036,0,0,1,1.037-1.037h5.534a1.036,1.036,0,0,1,1.037,1.037v3.468",
    transform: "translate(-48.49 -35.291)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    d: "M65.134,41.611V39.917a1.988,1.988,0,0,0-1.987-1.987H62.5a1.988,1.988,0,0,0-1.987,1.987h0v1.694h4.631Z",
    transform: "translate(-48.883 -34.151)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    cx: 0.451,
    cy: 0.451,
    r: 0.451,
    transform: "translate(17.097 13.295)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x1: 4.75,
    transform: "translate(2.917 9.732)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    x1: 4.75,
    transform: "translate(2.917 13.247)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M50.02,41.03H48.69",
    transform: "translate(-45.764 -34.813)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M48.69,35.046a2.937,2.937,0,0,1,2.755-1.956h6.782a2.933,2.933,0,0,1,2.731,1.892",
    transform: "translate(-46.315 -33.09)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFileDarkIcon);
export default __webpack_public_path__ + "static/media/secure-file-dark-icon.dba8921a623a8e36685d2b5b07864602.svg";
export { ForwardRef as ReactComponent };